/*
  Seeded random is currently disabled for impulse hosts and ports
  works only for users chance for starting the new chat

  In case of need for seeded random:
  replace Math.random with seededRandom(seed), where seed is any number

  export const seededRandom = (seed) => {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  };
*/
export const shuffleArray = (array = []) => {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

export const shuffleConnections = (connections = []) => {
  connections.forEach((item, index) => {
    connections[index].ports = shuffleArray(connections[index].ports);
  });

  return shuffleArray(connections);
}
